<template>
  <div>
    <a-card style="margin: 20px" title="商户协议">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>商户协议编号</span>
          <a-input v-model.trim="paramsData.merchantNo" allow-clear placeholder="请输入商户协议编号"/>
        </div>
        <div class="item">
          <span>商户协议名称</span>
          <a-input v-model.trim="paramsData.merchantName" allow-clear placeholder="请输入商户协议名称"/>
        </div>
        <div class="item">
          <span>状态</span>
          <a-select v-model="paramsData.status" allow-clear placeholder="全部">
            <a-select-option v-for="(item, key) in statusDict" :key="key" :value="key">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button v-if="$authority('payAgrConfigAdd')" type="primary" @click="addBtn">新增</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
              :scroll="{x: 1300}"
          >
            <template slot="status" slot-scope="text">
              <a-tag :color="getDictColor(statusDict, text)">{{ getDictLabel(statusDict, text) }}</a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button v-if="$authority('payAgrConfigView')" icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)">查看</a-button>
                <a-button
                    v-if="$authority('payAgrConfigEdit') && record.status === 'REJECTED'"
                    icon="edit" style="color: #52c41a;" type="link"
                    @click="editBtn(record)"
                >编辑</a-button>
                <a-button
                    v-if="$authority('payAgrConfigSubmit') && record.status === 'REJECTED'"
                    icon="upload" style="color: #1890ff;" type="link"
                    @click="submitApprovalBtn(record)"
                >提交审批</a-button>
                <a-button
                    v-if="$authority('payAgrConfigApprove') && record.status === 'PENDING'"
                    icon="audit" style="color: #faad14;" type="link"
                    @click="openApprovalModal(record)"
                >审批</a-button>
                <a-button
                    v-if="$authority('payAgrConfigPush') && record.status === 'PUSH_FAIL'"
                    :loading="pushLoadingId === record.id"
                    icon="send" style="color: #722ed1;" type="link"
                    @click="pushBtn(record)"
                >重推协议</a-button>
                <a-button
                    v-if="$authority('payAgrConfigInvalid') && canInvalid(record.status)"
                    icon="stop" style="color: #ff7a45;" type="link"
                    @click="invalidBtn(record)"
                >作废</a-button>
                <a-button
                    v-if="$authority('payAgrConfigDelete') && record.status === 'REJECTED'"
                    icon="delete" style="color: #ff4d4f;" type="link"
                    @click="deleteBtn(record)"
                >删除</a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :fn="getTableData" :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"/>
      </div>
    </a-card>

    <!-- 审批弹窗 -->
    <a-modal
        v-model="approvalModalVisible"
        :confirm-loading="approvalLoading"
        :destroyOnClose="true"
        title="商户协议审批"
        width="55%"
        @ok="handleApproval"
    >
      <div v-if="approvalRecord">
        <a-alert
            message="审批通过将同步向银行登记协议，耗时可能较长，请耐心等待。"
            show-icon
            style="margin-bottom: 16px;"
            type="info"
        />
        <a-descriptions :column="2" bordered size="small" style="margin-bottom: 16px;">
          <a-descriptions-item label="商户协议编号">{{ approvalRecord.merchantNo }}</a-descriptions-item>
          <a-descriptions-item label="商户协议名称">{{ approvalRecord.merchantName }}</a-descriptions-item>
          <a-descriptions-item label="付款方">
            <WalletInfo :account-name="approvalRecord.payerName" :account-no="approvalRecord.payerAccount" :show-account-name="true"/>
          </a-descriptions-item>
          <a-descriptions-item label="收款方">
            <WalletInfo :account-name="approvalRecord.payeeName" :account-no="approvalRecord.payeeAccount" :show-account-name="true"/>
          </a-descriptions-item>
        </a-descriptions>
        <a-form-model ref="approvalForm" :model="approvalForm" :rules="approvalRules" :label-col="{span: 4}" :wrapper-col="{span: 18}">
          <a-form-model-item label="审批动作" prop="action">
            <a-radio-group v-model="approvalForm.action">
              <a-radio value="PASS">通过（自动推送协议）</a-radio>
              <a-radio value="REJECT">驳回</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="审批意见" prop="opinion">
            <a-textarea v-model="approvalForm.opinion" :rows="3" :placeholder="approvalForm.action === 'REJECT' ? '驳回时必填' : '选填'"/>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import {payAgrDict, getDictLabel, getDictColor} from "@/utils/bizDict/payAgrDict";

const statusDict = {...payAgrDict.configStatus};
delete statusDict.default;

export default {
  name: 'PayAgrMerchantConfig',
  components: {LcfsPagination, WalletInfo},
  data() {
    return {
      statusDict,
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      tableData: [],
      paramsData: {
        merchantNo: "",
        merchantName: "",
        status: undefined,
      },
      pushLoadingId: null,
      firstActivated: true,
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 50
        },
        {title: "商户协议编号", dataIndex: "merchantNo", align: "center", width: 150},
        {title: "商户协议名称", dataIndex: "merchantName", align: "center", width: 160},
        {
          title: "付款方",
          dataIndex: "payerAccount",
          align: "center",
          width: 160,
          customRender: (text, row) => {
            if (!text) return <div>-</div>;
            return <WalletInfo accountNo={text} accountName={row.payerName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "收款方",
          dataIndex: "payeeAccount",
          align: "center",
          width: 160,
          customRender: (text, row) => {
            if (!text) return <div>-</div>;
            return <WalletInfo accountNo={text} accountName={row.payeeName} showAccountName={true}></WalletInfo>
          }
        },
        {title: "状态", dataIndex: "status", align: "center", width: 100, scopedSlots: {customRender: 'status'}},
        {title: "推送时间", dataIndex: "pushTime", align: "center", width: 150, customRender: (text) => this.formatDateTime(text)},
        {title: "创建时间", dataIndex: "createTime", align: "center", width: 150, customRender: (text) => this.formatDateTime(text)},
        {title: "操作", key: "action", width: 320, align: "center", fixed: 'right', scopedSlots: {customRender: 'action'}}
      ],

      // 审批弹窗
      approvalModalVisible: false,
      approvalLoading: false,
      approvalRecord: null,
      approvalForm: {action: 'PASS', opinion: ''},
      approvalRules: {
        action: [{required: true, message: '请选择审批动作', trigger: 'change'}],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  activated() {
    // 列表页被 keep-alive 缓存后，从新增/编辑页返回时 mounted 不再触发，这里补刷新
    if (this.firstActivated) {
      this.firstActivated = false;
      return;
    }
    this.getTableData();
  },
  methods: {
    getDictLabel,
    getDictColor,

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    canInvalid(status) {
      return ['PENDING', 'APPROVED', 'EFFECTIVE', 'PUSH_FAIL'].includes(status);
    },

    async getTableData() {
      try {
        const res = await this.api.getPayAgrConfigList({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {merchantNo: "", merchantName: "", status: undefined};
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    addBtn() {
      this.$router.push({path: '/pay-agr/merchantConfig/create', query: {mode: 'add'}});
    },

    viewBtn(record) {
      this.$router.push({path: '/pay-agr/merchantConfig/detail', query: {configId: record.id}});
    },

    editBtn(record) {
      this.$router.push({path: '/pay-agr/merchantConfig/create', query: {mode: 'edit', configId: record.id}});
    },

    submitApprovalBtn(record) {
      this.$confirm({
        title: '提交审批',
        content: `确认将配置【${record.merchantNo}】重新提交审批？`,
        onOk: async () => {
          const res = await this.api.submitPayAgrConfigApproval({configId: record.id});
          if (res.code === 200) {
            message.success('已提交审批');
            this.getTableData();
          } else {
            message.warning(res.info || '提交失败');
          }
        },
      });
    },

    openApprovalModal(record) {
      this.approvalRecord = record;
      this.approvalForm = {action: 'PASS', opinion: ''};
      this.approvalModalVisible = true;
    },

    handleApproval() {
      this.$refs.approvalForm.validate(async (valid) => {
        if (!valid) return;
        if (this.approvalForm.action === 'REJECT' && !this.approvalForm.opinion.trim()) {
          message.warning('驳回时审批意见必填');
          return;
        }
        this.approvalLoading = true;
        try {
          const res = await this.api.approvePayAgrConfig({
            configId: this.approvalRecord.id,
            action: this.approvalForm.action,
            opinion: this.approvalForm.opinion,
          });
          if (res.code === 200 && res.data) {
            if (this.approvalForm.action === 'PASS') {
              if (res.data.status === 'EFFECTIVE') {
                message.success('审批通过，协议推送成功，配置已生效');
              } else {
                message.warning('审批通过，但协议推送失败（状态：' + this.getDictLabel(this.statusDict, res.data.status) + '），可在列表中重推');
              }
            } else {
              message.success('已驳回');
            }
            this.approvalModalVisible = false;
            this.getTableData();
          } else {
            message.warning(res.info || '审批失败');
          }
        } catch (error) {
          console.error("审批失败:", error);
          message.error('审批失败');
        } finally {
          this.approvalLoading = false;
        }
      });
    },

    pushBtn(record) {
      this.$confirm({
        title: '重推协议',
        content: `确认重新向银行推送配置【${record.merchantNo}】的协议？`,
        onOk: async () => {
          this.pushLoadingId = record.id;
          try {
            const res = await this.api.pushPayAgrAgreement({configId: record.id});
            if (res.code === 200 && res.data) {
              if (res.data.status === 'EFFECTIVE') {
                message.success('协议推送成功，配置已生效');
              } else {
                message.warning('协议推送仍失败，请查看详情中的推送结果明细');
              }
              this.getTableData();
            } else {
              message.warning(res.info || '推送失败');
            }
          } catch (error) {
            console.error("推送失败:", error);
            message.error('推送失败');
          } finally {
            this.pushLoadingId = null;
          }
        },
      });
    },

    invalidBtn(record) {
      this.$confirm({
        title: '作废配置',
        content: `确认作废配置【${record.merchantNo}】？作废后不可再基于该配置创建订单（不影响银行已登记的协议）。`,
        okType: 'danger',
        onOk: () => this.doInvalid(record, false),
      });
    },

    async doInvalid(record, forceInvalid) {
      const res = await this.api.invalidPayAgrConfig({configId: record.id, forceInvalid});
      if (res.code === 200) {
        message.success('已作废');
        this.getTableData();
      } else if (res.code === 460) {
        // 存在在途订单：后端返回 460，弹二次确认后强制作废（doc §12#10）
        this.$confirm({
          title: '存在在途订单',
          content: res.info,
          okText: '仍要作废',
          okType: 'danger',
          onOk: () => this.doInvalid(record, true),
        });
      } else {
        message.warning(res.info || '作废失败');
      }
    },

    deleteBtn(record) {
      this.$confirm({
        title: '删除配置',
        content: `确认删除配置【${record.merchantNo}】及其服务费规则？仅已拒绝状态可删除。`,
        okType: 'danger',
        onOk: async () => {
          const res = await this.api.deletePayAgrConfig({configId: record.id});
          if (res.code === 200) {
            message.success('已删除');
            this.getTableData();
          } else {
            message.warning(res.info || '删除失败');
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}
</style>
